import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import { Button, Radio, RadioGroup } from '@salesforce/design-system-react';

import './SelectionDetailsAssetFilterPane.scss';

class SelectionDetailsAssetFilterPane extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eligibleValue: this.props.filter.eligibleValue
    };
  }

  handleSetEligibleFilter(value) {
    this.setState({ eligibleValue: value });

    const filters = this.props.filter || {};
    const filter = { eligibleValue: value };

    this.props.actions.updateAssetFilter({ ...filters, ...filter });
  }

  /**
   * Closes any open popovers and resets redux filters to nothing
   */
  handleRemoveAllFilters() {
    this.setState({
      eligibleValue: null
    });

    this.props.actions.updateAssetFilter({
      ...this.props.filter,
      eligibleValue: null
    });
  }

  render() {
    const { formatMessage } = this.props.intl;

    const eligibleGroupLabel = {
      label: formatMessage({
        id: 'components.ecs.selectionBrowser.details.filter.eligibleTitle'
      })
    };
    const eligibleGroups = [
      {
        id: 'eligible',
        value: formatMessage({
          id: 'components.ecs.selectionBrowser.details.filter.eligible'
        })
      },
      {
        id: 'notEligible',
        value: formatMessage({
          id: 'components.ecs.selectionBrowser.details.filter.notEligible'
        })
      }
    ];

    return (
      <div className="selection-details-asset-filter-pane slds-box">
        <div className="selection-details-asset-filter-title-box">
          <div className="selection-details-asset-filter-title">
            <FormattedMessage id="components.ecs.selectionBrowser.details.filter.title" />
          </div>
          <Button
            className="close-filter"
            iconCategory="utility"
            iconName="close"
            iconSize="medium"
            variant="base"
            onClick={this.props.onClose}
          />
        </div>
        <div className="selection-details-asset-filters">
          <RadioGroup
            labels={eligibleGroupLabel}
            onChange={event => this.handleSetEligibleFilter(event.target.value)}
            name={this.props.name}
          >
            {eligibleGroups.map(group => (
              <Radio
                key={group.id}
                id={group.id}
                labels={{ label: group.value }}
                value={group.id}
                checked={this.state.eligibleValue === group.id}
                variant="base"
              />
            ))}
          </RadioGroup>
          <div className="selection-details-filter-actions">
            <span
              className="link clear-all-link"
              onClick={this.handleRemoveAllFilters.bind(this)}
            >
              <FormattedMessage id="components.ecs.selectionBrowser.details.filter.clearAll" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

SelectionDetailsAssetFilterPane.propTypes = {
  actions: PropTypes.object,
  filter: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  location: PropTypes.object
};

export default injectIntl(SelectionDetailsAssetFilterPane);
